<script>
  export let displayName;
  export let photoURL;
  export let width = 30;
  import { navigateTo } from "yrv";
  import { auth, googleProvider } from "../firebase";
  import { authState } from "rxfire/auth";

  function handleSignOut() {
    auth
      .signOut()
      .then(function() {
        console.log("Sign-out successful");
      })
      .catch(function(error) {
        console.log("Error signing out");
      });
  }
</script>

<style>
  .avatar {
    grid-area: avatar;
    @apply shadow-lg rounded-full self-center border-2 border-white ;
  }
  img {
    padding: 0;
    margin: 0;
  }
</style>

<div on:click={()=>{navigateTo("/#profile")}}>
  <img class="avatar" title={displayName} src={photoURL} width={width} alt="avatar" />    
</div>


